import React from "react";

class Footer extends React.Component {
    render() {

        return ( 
         <footer>

             <p>Made by <a href="http://www.philbolles.com">Phil Bolles</a></p>
         </footer>
        )
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js